import { useAppSelector } from '../../hooks';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import { redirectKey } from './AuthLayout';

export const StrictPublicLayout = () => {
  const user = useAppSelector((state) => state.user);
  const [searchParams] = useSearchParams();

  if (!user) return <Outlet />;

  const redirectAfterLoginPath = searchParams.get(redirectKey);
  return <Navigate to={redirectAfterLoginPath ?? ROUTES.home} />;
};
